import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AdminEmailListService } from "../service";
import { handleError } from "../../../shared/functions/handleError";
import { IEmailStats } from "../../../shared/interfaces/email-list/IEmailList";
import InvoiceStatisticsSkeleton from "../../invoice/components/InvoiceStatisticsSkeleton";
import Grid from "@mui/material/Grid2";
import StatisticCard from "../../../shared/components/StatisticCard";
import { useTranslation } from "react-i18next";
import { getEmailListStatusIcon } from "../../../shared/functions/getEmailListStatusIcon";

const statsKeys = [
  "name",
  "successRate",
  "pending",
  "sent",
  "failed",
  "total",
  "language",
  "category",
];

const EmailListStats = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState<IEmailStats | undefined>(undefined);
  useEffect(() => {
    if (id) {
      AdminEmailListService.stats(id).then(setData).catch(handleError);
    }
  }, [id]);
  return (
    <>
      {data === undefined ? (
        <InvoiceStatisticsSkeleton />
      ) : (
        <Grid container spacing={2} sx={{ mb: "20px" }}>
          {statsKeys?.map((statistic) => {
            return (
              <StatisticCard
                key={statistic}
                size={{
                  xs: 12,
                  sm: 6,
                  lg: 3,
                }}
                getTitle={(item) => t(`emails.${item}`)}
                getIcon={(item) =>
                  getEmailListStatusIcon(item as keyof IEmailStats)
                }
                title={statistic}
                getValue={(item) => String(data[item as keyof typeof data])}
              />
            );
          })}
        </Grid>
      )}
    </>
  );
};

export default EmailListStats;
